export default class CreateTechniqueDto {
  id: string | null;
  stepIds: string[] | null;

  constructor() {
    this.id = null;
    this.stepIds = null;
  }
}
